import Vue from 'vue'
import vuex from 'vuex'
import base from './base'
import pg from './pg'
import upload from './upload'

Vue.use(vuex)
export default new vuex.Store({
  modules: {
    base,
    pg,
    upload
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js